module.exports = "/build/images/marker.643395a0.png";